﻿import { Circle as CircleStyle, Icon, Fill, Stroke, Style, Text } from 'ol/style.js';
import { WFS as WFSFormat, GML as GMLFormat, WKT, GeoJSON } from 'ol/format';
import Collection from 'ol/Collection.js';
import { Utility } from '../Utility.js';
export { RailwayTool };

/**
 * Class RoadBuilderTool
 */
const RailwayTool = function () {

    // Define this
    var myRailwayTool = this;

    // -- begin private variable ------------------------------------------------------------------

    // Map
    this._mapSgs = null;

    // Utility
    this._utility = new Utility();

    // Already initialize
    this._toolInitialize = false;

    // Style for selected layer vector
    this._tooltipsStylesSelected = [
        new Style({
            image: new CircleStyle({
                radius: 10,
                stroke: new Stroke({
                    color: 'rgba(255, 255, 0, 0.5)',
                    width: 5
                }),
                fill: new Fill({
                    color: 'rgba(0, 0, 255, 0.2)'
                })
            }),
            stroke: new Stroke({
                color: 'rgba(255, 255, 0, 0.5)',
                width: 10
            }),
            fill: new Fill({
                color: 'rgba(0, 0, 255, 0.5)'
            })
        })
    ];

    // Railway point layer name
    this._layerNameRailwayPoint = "railway_point";

    // Railway info point info
    this._railwayPointInfo = {};

    // Hash rail way point
    this._HashRailwayPoint = {};

    // Hash of classification information
    this._hashClassificationInfo = {
        "0": {
            class: "no-problem",
            description: "Without problem"
        },
        "1": {
            class: "moderate-problem",
            description: "Moderate problem"
        },
        "2": {
            class: "considerable-problem",
            description: "Considerable problem"
        },
        "3": {
            class: "severe-problem",
            description: "Severe problem"
        }
    };

    // Index slider
    this._indexSlider = null;

    // Index slider value
    this._indexSliderValue = 0

    // Max index slider value
    this._maxSliderValue = 15000;

    // All railway point feature colection
    this._collectionAllFeatureRailway = new Collection();

    // -- end private variable --------------------------------------------------------------------

    // -- begin public variable -------------------------------------------------------------------

    // -- end public variable ---------------------------------------------------------------------

    // -- begin public method ---------------------------------------------------------------------

    /**
     * Option railway tool
     */
    this.BuildMenuBar = function ()
    {
        // -- Input Search ------------------------------------------------------------------------
        const searchIndexGroup = document.createElement('div');
        searchIndexGroup.ClassName = "form-group";
        
        // Input element
        const searchIndexInput = document.createElement('input');
        searchIndexInput.id = "id-railway-search-index-input";
        searchIndexInput.className = "form-control";
        searchIndexInput.setAttribute("type", "text");
        searchIndexInput.setAttribute("placeholder", "Search index");
        searchIndexGroup.appendChild(searchIndexInput);

        // Button search
        const buttonSearchIndex = document.createElement('button');
        buttonSearchIndex.id = "id-railway-search-index-btn";
        buttonSearchIndex.className = "btn btn-primary pull-right railway-search-index-btn";
        buttonSearchIndex.setAttribute("type", "button");
        buttonSearchIndex.setAttribute("title", "Goto Index");
        const aSearchIndex = document.createElement('a');
        buttonSearchIndex.appendChild(aSearchIndex);
        const iSearchIndex = document.createElement('i');
        iSearchIndex.className = "material-icons";
        iSearchIndex.innerHTML = "search";
        aSearchIndex.appendChild(iSearchIndex);
        searchIndexGroup.appendChild(buttonSearchIndex);

        /**
         * Search index event
         */
        const handleSearchIndex = function ()
        {
            // Get index
            var index = $('#id-railway-search-index-input').val();

            // Valid index
            if(!myRailwayTool._ValidIndex(index))
            {
                toastr["warning"]("Invalid index");
                return;
            }

            // Set slide
            myRailwayTool._SetSlideValue(index);

            // Search index
            myRailwayTool.OpenRailwayLocationInformationByIndex(index);
        }

        buttonSearchIndex.addEventListener('click', handleSearchIndex, false);
        buttonSearchIndex.addEventListener('touchstart', handleSearchIndex, false);


        // -- Slider index ------------------------------------------------------------------------
        const sliderIndexZone = document.createElement('div');
        sliderIndexZone.className = "railway-search-index-slider-zone";

        const sliderIndexInput = document.createElement('input');
        sliderIndexInput.id = "id-railway-search-index-input-slider";
        sliderIndexInput.setAttribute("type", "text");
        sliderIndexInput.setAttribute("data-slider-id", "ex1Slider");
        sliderIndexZone.appendChild(sliderIndexInput);

        // -- Slider value ------------------------------------------------------------------------
        const sliderIndexDivValue = document.createElement('div');
        sliderIndexDivValue.className = "railway-search-index-value-slider";

        const sliderIndexSpanValue = document.createElement('div');
        sliderIndexSpanValue.id = "id-railway-search-index-value-slider";
        sliderIndexDivValue.appendChild(sliderIndexSpanValue);

        // -- Menu panel road builder tool --------------------------------------------------------
        const menuPanelRoadBuilderTool = document.createElement('div');
        menuPanelRoadBuilderTool.appendChild(searchIndexGroup);
        menuPanelRoadBuilderTool.appendChild(sliderIndexZone);
        menuPanelRoadBuilderTool.appendChild(sliderIndexDivValue);

        return menuPanelRoadBuilderTool;
    }

    /**
     * Open offcanvas map with data location information
     * @param {Feature} feature, feature point railway
     */
    this.OpenRailwayLocationInformation = function(feature)
    {
        var objProperty = feature.getProperties();
        var valueSplit = [];
        myRailwayTool._railwayPointInfo = {
            index: objProperty.index,
            distance: objProperty.dist,
            global_classification: objProperty.global_classification,
            bitola: {
                value: objProperty.bitola_chart_balloon_text.replace("Bitola ", ""),
                color: objProperty.bitola_chart_color,
                classification: objProperty.bitola_chart_classification
            },
            long_leveling: {
                classification: objProperty.long_leveling_classification,
                left: {
                    value: objProperty.long_leveling_chart_left_balloon_text.replace("Long level L ", ""),
                    color: objProperty.long_leveling_chart_left_color,
                    classification: objProperty.long_leveling_chart_left_classification
                },
                right: {
                    value: objProperty.long_leveling_chart_right_balloon_text.replace("Long level R ", ""),
                    color: objProperty.long_leveling_chart_right_color,
                    classification: objProperty.long_leveling_chart_right_classification
                }
            },
            align: {
                classification: objProperty.align_chart_classification,
                left: {
                    value: objProperty.align_chart_left_balloon_text.replace("Align left ", ""),
                    color: objProperty.align_chart_left_color,
                    classification: objProperty.align_chart_left_classification
                },
                right: {
                    value: objProperty.align_chart_right_balloon_text.replace("Align right ", ""),
                    color: objProperty.align_chart_right_color,
                    classification: objProperty.align_chart_right_classification
                }
            }
        }

        // Clear selection
        myRailwayTool._mapSgs.layerHighlightOverlay.getSource().clear();

        // Highlight feature
        myRailwayTool._mapSgs.SetFeaturesHighlightByArray3(feature, false, myRailwayTool._tooltipsStylesSelected)

        // -- Fill form --

        // Fill index
        $('#id-railway-info-form .index')[0].innerHTML = myRailwayTool._railwayPointInfo.index;
        $('#id-railway-info-index').val(objProperty.index);

        // Fill distance
        $('#id-railway-info-form .distance')[0].innerHTML = (Math.round((myRailwayTool._railwayPointInfo.distance*0.001) * 1000)/1000) + " km";

        // -- Bitola --
        valueSplit = myRailwayTool._railwayPointInfo.bitola.value.split("(");
        $("#id-railway-info-bitola")[0].innerHTML = valueSplit[0] + "<br>(" + valueSplit[1];
        $('#id-railway-info-bitola').parent().css("border", "1px solid " + myRailwayTool._railwayPointInfo.bitola.color);
        $('#id-railway-info-classification .bitola > div')[0].className = "railway-info-classification " + myRailwayTool._hashClassificationInfo[myRailwayTool._railwayPointInfo.bitola.classification].class;
        $('#id-railway-info-classification .bitola > div').attr('title', myRailwayTool._hashClassificationInfo[myRailwayTool._railwayPointInfo.bitola.classification].description);

        // -- Long leveling --
        $('#id-railway-info-classification .long-leveling > div')[0].className = "railway-info-classification " + myRailwayTool._hashClassificationInfo[myRailwayTool._railwayPointInfo.long_leveling.classification].class;
        $('#id-railway-info-classification .long-leveling > div').attr('title', myRailwayTool._hashClassificationInfo[myRailwayTool._railwayPointInfo.long_leveling.classification].description);

        valueSplit = myRailwayTool._railwayPointInfo.long_leveling.left.value.split("(");
        $("#id-railway-info-long-leveling-left")[0].innerHTML = valueSplit[0] + "<br>(" + valueSplit[1];
        $('#id-railway-info-long-leveling-left').parent().css("border", "1px solid " + myRailwayTool._railwayPointInfo.long_leveling.left.color);

        valueSplit = myRailwayTool._railwayPointInfo.long_leveling.right.value.split("(");
        $("#id-railway-info-long-leveling-right")[0].innerHTML = valueSplit[0] + "<br>(" + valueSplit[1];
        $('#id-railway-info-long-leveling-right').parent().css("border", "1px solid " + myRailwayTool._railwayPointInfo.long_leveling.right.color);

        // -- Align --
        $('#id-railway-info-classification .align > div')[0].className = "railway-info-classification " + myRailwayTool._hashClassificationInfo[myRailwayTool._railwayPointInfo.align.classification].class;
        $('#id-railway-info-classification .align > div').attr('title', myRailwayTool._hashClassificationInfo[myRailwayTool._railwayPointInfo.align.classification].description);

        valueSplit = myRailwayTool._railwayPointInfo.align.left.value.split("(");
        $("#id-railway-info-align-left")[0].innerHTML = valueSplit[0] + "<br>(" + valueSplit[1];
        $('#id-railway-info-align-left').parent().css("border", "1px solid " + myRailwayTool._railwayPointInfo.align.left.color);
        
        valueSplit = myRailwayTool._railwayPointInfo.align.left.value.split("(");
        $("#id-railway-info-align-right")[0].innerHTML = valueSplit[0] + "<br>(" + valueSplit[1];
        $('#id-railway-info-align-right').parent().css("border", "1px solid " + myRailwayTool._railwayPointInfo.align.right.color);

        // Open offcanvas data location information
        $('#id-railway-info').addClass('active');
    }

    /**
     * Open offcanvas map with data location information by index
     * @param {int} index, index
     */
    this.OpenRailwayLocationInformationByIndex = function(index)
    {

        var feature = myRailwayTool._collectionAllFeatureRailway.getArray()[index];

        myRailwayTool.OpenRailwayLocationInformation(feature);

        //// Get layer info
        //var layerInfo = myRailwayTool._mapSgs.layerTree.FindLayerInfoOnListLayer(myRailwayTool._layerNameRailwayPoint);

        //// Get feature by index
        //var getFeature = $.ajax({
        //    method: "GET",
        //    async: true,
        //    url: layerInfo.geoserver + "/wfs",
        //    data: {
        //        "service": 'wfs',
        //        "version": '2.0.0',
        //        "request": 'GetFeature',
        //        "typeNames": layerInfo.workspace + ':' + layerInfo.layerName,
        //        "cql_filter": "index == " + index,
        //        "propertyName": "*",
        //        "outputFormat": 'application/json'
        //    }
        //});

        //getFeature.done(function (data, textStatus, jqXHR) {
        //    if (data.features) {
        //        if (data.features.length > 0) {
        //            var feature = (new GeoJSON()).readFeatures(data.features[0])[0];
        //            myRailwayTool.OpenRailwayLocationInformation(feature);
        //        }
        //        else
        //            toastr["warning"]("Index with no data");
        //    }
        //    else {
        //        toastr["warning"]("Index with no data");
        //    }
        //});
    }

    /**
     * Get all railway feature point
     */
    this.GetAllFeaturePoint = function()
    {
        // Get layer info
        var layerInfo = myRailwayTool._mapSgs.layerTree.FindLayerInfoOnListLayer(myRailwayTool._layerNameRailwayPoint);

        // Get feature by index
        var getFeature = $.ajax({
            method: "GET",
            async: true,
            url: layerInfo.geoserver + "/wfs",
            data: {
                "service": 'wfs',
                "version": '2.0.0',
                "request": 'GetFeature',
                "typeNames": layerInfo.workspace + ':' + layerInfo.layerName,
                //"cql_filter": "index == " + index,
                "propertyName": "*",
                "outputFormat": 'application/json'
            }
        });

        getFeature.done(function (data, textStatus, jqXHR) {
            if (data.features) {
                if (data.features.length > 0) {
                    for(var i = 0; i < data.features.length; i++)
                    {
                        var feature = (new GeoJSON()).readFeatures(data.features[i])[0];
                        myRailwayTool._collectionAllFeatureRailway.push(feature);
                    }
                }
            }
        });
    }

    /**
     * Init slider index
     */
    this.InitSliderIndex  = function()
    {
        if (!myRailwayTool._indexSlider)
        {
            myRailwayTool._indexSlider = new Slider("#id-railway-search-index-input-slider", {
                step: 10,
                min: 0,
                max: myRailwayTool._maxSliderValue,
                value: myRailwayTool._indexSliderValue,
                tooltip: 'hide',
                width: 500
            });
        }

        // Update index value
        myRailwayTool._indexSlider.on("slide", function (sliderValue)
        {
            $('#id-railway-search-index-value-slider')[0].innerHTML = sliderValue;

            myRailwayTool._indexSliderValue = sliderValue;
            myRailwayTool.OpenRailwayLocationInformationByIndex(myRailwayTool._indexSliderValue);
        });

        // On Update 
        //myRailwayTool._indexSlider.on("change", function (obj)
        //{
        //    $('#id-railway-search-index-value-slider')[0].innerHTML = obj.newValue;

        //    myRailwayTool._indexSliderValue = obj.newValue;
        //    myRailwayTool.OpenRailwayLocationInformationByIndex(myRailwayTool._indexSliderValue);

        //    //myRailwayTool._indexSliderValue = obj.newValue;

        //    //myRailwayTool.OpenRailwayLocationInformationByIndex(myRailwayTool._indexSliderValue);
        //});
    }

    // -- end public method -----------------------------------------------------------------------

    // -- begin private method --------------------------------------------------------------------

    /**
     * Set slide value
     * @param{int} index, index value
     */
    this._SetSlideValue = function(index)
    {
        $('#id-railway-search-index-value-slider')[0].innerHTML = index;
        myRailwayTool._indexSlider.setValue(index);

        myRailwayTool._indexSliderValue = index;
        myRailwayTool.OpenRailwayLocationInformationByIndex(myRailwayTool._indexSliderValue);
    }

    /**
     * Clean railway info
     */
    this._CleanRailwayInfo = function()
    {
        myRailwayTool._mapSgs.layerHighlightOverlay.getSource().clear();
        $('#id-railway-info').removeClass('active');
    }

    /**
     * Valid if it is well formated index
     */
    this._ValidIndex = function(index)
    {
        var valid = false;

        if(myRailwayTool._utility.ValidNumber(index))
        {
            if(parseInt(index).toString() === index)
                return true;
        }

        return valid;
    }

    // -- end private method ----------------------------------------------------------------------

    // -- begin event -----------------------------------------------------------------------------

    /**
     * Close data location information for railways
     */
    $('#id-railway-info-close').on('click', function() {
        myRailwayTool._CleanRailwayInfo();
    });

    /**
     * Go left fast previous index
     */
    $('#id-railway-info-index-btn-fast-previous').on('click', function() {
        var index = $('#id-railway-info-index').val();
        var previousIndex = parseInt(index)-100;
        if(previousIndex > 0) {
            myRailwayTool._SetSlideValue(previousIndex);
            myRailwayTool.OpenRailwayLocationInformationByIndex(previousIndex);
        }
    });

    /**
     * Go left previous index
     */
    $('#id-railway-info-index-btn-previous').on('click', function() {
        var index = $('#id-railway-info-index').val();
        var previousIndex = parseInt(index)-1;
        if(previousIndex > 0) {
            var previousIndex = parseInt(index)-1;
            myRailwayTool._SetSlideValue(previousIndex);
            myRailwayTool.OpenRailwayLocationInformationByIndex(previousIndex);
        }
    });

    /**
     * Go right next index
     */
    $('#id-railway-info-index-btn-next').on('click', function() {
        var index = $('#id-railway-info-index').val();
        var indexNext = parseInt(index)+1;
        myRailwayTool._SetSlideValue(indexNext);
        myRailwayTool.OpenRailwayLocationInformationByIndex(indexNext);
    });

    /**
     * Go right fast next index
     */
    $('#id-railway-info-index-btn-fast-next').on('click', function() {
        var index = $('#id-railway-info-index').val();
        var indexNext = parseInt(index)+100;
        myRailwayTool._SetSlideValue(indexNext);
        myRailwayTool.OpenRailwayLocationInformationByIndex(indexNext);
    });

    // -- end event -------------------------------------------------------------------------------
};

/**
 * Init railway tool
 * @param {object} mapSgs, map object
 */
RailwayTool.prototype.Init = function (mapSgs) {
    if(!this._toolInitialize)
    {
        this._toolInitialize = true;

        // Set map info
        this._mapSgs = mapSgs;

        // Goto index if exists index in addicional parameters
        var addicionalParams = this._mapSgs._settings._mapSettings.additional_params;
        if(addicionalParams && addicionalParams.context === "railway_tool" && addicionalParams.index)
        {
            if(!this._ValidIndex(addicionalParams.index))
            {
                toastr["warning"]("Invalid index");
                return;
            }

            // Search index
            this.OpenRailwayLocationInformationByIndex(addicionalParams.index);
        }

        // Get all point feature
        this.GetAllFeaturePoint();
    }
};